import React from "react";
import Footer from "../footer";
import Navbar from "../navbar";


const Layout = ({ children, openModal }) => {
    return (
        <div className="">
            <Navbar openModal={openModal} />
            <main className="overflow-hidden">{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;
